
import { required, email } from 'vuelidate/lib/validators'

export default {
  profile: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    phones: {
      mobile: {
        required
      }
    },
    birthdate: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/validations.js